// extracted by mini-css-extract-plugin
export default {"hospitals":"Hospitals_hospitals__gX-Ks","contacts-wrap":"Hospitals_contacts-wrap__kaGhd"};